import React from 'react'

const Manual_creacion_de_tipo_de_pago = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     DELIVERECT - Creación de Tipo de Pago
     </h2>
     <iframe
          src="https://scribehow.com/embed/DELIVERECT__Creacion_de_Tipo_de_Pago__aLB82zjZQB6OWBnQHbE1rg?as=scrollable"
          className="scribe-iframe-deliverect-3"
          width="100%"
          height="3800"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_creacion_de_tipo_de_pago